export default __webpack_public_path__ + "static/media/green.f199a609.png";